import { render, staticRenderFns } from "./PreRegisterParking.vue?vue&type=template&id=250f22fc&scoped=true"
import script from "./PreRegisterParking.vue?vue&type=script&lang=js"
export * from "./PreRegisterParking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f22fc",
  null
  
)

export default component.exports